<template>
  <div class="page_footer">
    <div class="foot_body">

    <div class="site_info">

      <div class="site_intro">
        <div class="si_top">
          <img src="../assets/footlogo.png">
        </div>
        <div class="si_phone">
        <div class="si_bot1">{{itemData.rx}}</div>
        <div class="si_bot2">400-178-1617</div>
        </div>
      </div>

      <div class="site_map">

        <div class="map_list" v-for="item in itemData.itemLi">
          <div class="d_span">
          <span class="foot_span">{{item.span}}</span>
          </div>
        <div class="d_a" v-for="item2 in item.aa">
          <a class="foot_a"  :href="item2.hrf" >{{item2.text1}}</a>
      </div>
        </div>


      </div>

    </div>
    <div class="foot_last">
    <div id="footer" class="foot_d">

      <a href="http://beian.miit.gov.cn" target="_blank" style="color: #999999;">{{itemData.icp}}</a> <a style="color: #999999;" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302007356" class="beian" data-v-e3e54566><img src="../assets/beian.png" style="width:13px; height: 13px" >{{itemData.ga}}</a> {{itemData.name}}

    </div>
<!--      <div class="foot_t">-->
<!--        <img class="foot_img_l" src="../assets/image/t1.png">-->
<!--        <img class="foot_img_l" src="../assets/image/t2.png">-->
<!--        <img class="foot_img_l" src="../assets/image/t3.png">-->
<!--        <img class="foot_img_l" src="../assets/image/t4.png">-->

<!--      </div>-->
    </div>
    </div>

  </div>

</template>

<script>
import {Data} from "./js/Footer";

export default {
  name: 'abc',
  data() {
    return {
      dataAll: Data,
      itemData: {},
    }
  },
  mounted() {
    let that = this;

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }
  },
  methods: {
    choiceEn() {
      let that = this;
      console.log(that.$parent.message)
      for(let index in that.dataAll){
        let itemData= that.dataAll[index];
        if(that.$parent.message == itemData.type){
          that.itemData = itemData;
          break;
        }
      }
    }
  }
}
</script>

<style scoped>
.foot_img_l{
  height: 30px;
  width: 30px;
  margin-right: 2px;
}
.foot_last{
  margin-top: 140px;
  display: flex;
}
.foot_t{
  width: 150px;
  height: 30px;
  margin-left: 450px;
}
.foot_d{
  font-family: SourceHanSansCN;
  font-size: 16px;
  color: #999999;
  text-align: justify;
  line-height: 34px;
  white-space: pre-wrap;
}
.d_a{
  width: 100%;
  display: flex;
}
.d_span{
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
}
.map_list{
  float: right;
  width:189px;
}

.site_intro{
  margin-right: 60px;
}
.foot_a{
  font-family: SourceHanSansCN;
  font-size: 16px;
  color: #999999;
  text-align: center;
  line-height: 34px;
  width: 100%;
  cursor: pointer;
}
.foot_span{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  width: 100%;
}
.si_phone{
  margin-top: 80px;
}
.si_bot2{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #999999;
  text-align: justify;
  line-height: 34px;
}
.si_bot1{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #FFFFFF;
  text-align: justify;
}
.site_info{
  width: 100%;
  height: 220px;
  margin-top: 100px;
  display: flex;
}
.foot_body{
  width: 72.92%;
}
.page_footer{
  height: 568px;
  width: 100%;
  background-color: #000000;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue